import * as React from 'react';
import cx from 'classnames';
import get from 'lodash/get';
import styles from './RichNavigation.css';
import { Chevron } from 'components/Icons/Icons';
import isEmpty from 'lodash/isEmpty';
import LinkMaybe from 'components/LinkMaybe/LinkMaybe';
import StringWidget from 'components/StringWidget';
import omnitureHelper from 'utils/omnitureHelper';
import { MID_LEVEL } from 'constants/RichNavigationConstants';
class NavigationSubMenu extends React.Component {
    constructor(props) {
        super(props);
        this.selectItem = (index) => {
            this.state.selectedIndex !== index &&
                this.setState({
                    selectedIndex: index
                });
        };
        this.isCordinatesinSlope = () => {
            const x = this.currentY - this.y1 + this.currentX;
            const y = this.currentY + this.currentX - this.x1;
            return this.x1 < x && x < this.currentX && this.y1 < y && y < this.currentY;
        };
        this.makeCategorySelection = (index, timeOut = 30) => {
            this.index = index;
            this.timer = setInterval(() => {
                clearInterval(this.timer);
                this.selectItem(this.index);
            }, timeOut);
        };
        this.handleMouseEnter = (index) => (e) => {
            this.x1 = e.clientX;
            this.y1 = e.clientY;
            !this.isCordinatesinSlope() && this.makeCategorySelection(index, 20);
        };
        this.handleMouseLeave = (e) => {
            this.currentX = e.clientX;
            this.currentY = e.clientY;
            clearInterval(this.timer);
        };
        this.handleMouseMove = (index) => (e) => {
            this.currentX = e.clientX;
            this.currentY = e.clientY;
            if (!this.isCordinatesinSlope()) {
                clearInterval(this.timer);
                this.makeCategorySelection(index, 20);
            }
        };
        this.getmenuItem = (item, index) => {
            const { selectedIndex } = this.state;
            const isLeafNode = isEmpty(get(item, 'value.items'));
            const isMidLevel = get(item, 'value.levelType') === MID_LEVEL;
            const selectedItemStyle = (!isLeafNode && index === selectedIndex && styles['highlight']) || '';
            // Track mouse movement if its not a leaf node or if it's a leaf node in L1 menu
            const fireMouseEvent = !isLeafNode || (isMidLevel && isLeafNode);
            const mouseHoverEvent = (fireMouseEvent && this.handleMouseEnter(index)) || undefined;
            const mouseLeaveEvent = (fireMouseEvent && this.handleMouseLeave) || undefined;
            const mouseMoveEvent = (fireMouseEvent && this.handleMouseMove(index)) || undefined;
            let url = get(item, ['action', 'url']);
            if (url) {
                url = omnitureHelper.createTrackingUrl(url, item);
            }
            const text = get(item, ['value', 'text']) || '';
            return (<LinkMaybe preventAnchorLink={false} to={url} onMouseEnter={mouseHoverEvent} onMouseLeave={mouseLeaveEvent} onMouseMove={mouseMoveEvent} key={index} className={cx(styles['submenu-list-item'], { [styles['child-item']]: isLeafNode }, selectedItemStyle)}>
				{text}
				{!isLeafNode && selectedItemStyle && (<Chevron width={5} height={8} className={cx(styles['chevron-hightlight'])} pathClassName={styles['chevron-hightlight-path']}/>)}
			</LinkMaybe>);
        };
        this.getMenuItemList = (items, classNames, title) => {
            return (<div className={classNames}>
				{title && <StringWidget className={styles['title']} strKey="navigationMenuTitle" attributes={{ title }}/>}
				{items.map((item, index) => {
                return this.getmenuItem(item, index);
            })}
			</div>);
        };
        this.state = {
            selectedIndex: 0
        };
    }
    componentWillUnmount() {
        clearInterval(this.timer);
    }
    render() {
        const { items } = this.props.data;
        const { selectedIndex } = this.state;
        const selectedCategory = get(this.props.data, ['items', selectedIndex]) || {};
        const itemsInSelectedCategory = get(selectedCategory, ['value', 'items']) || {};
        const selectedCategoryTitle = get(selectedCategory, ['value', 'text']);
        return (items && (<div className={styles['submenu-container']}>
					{this.getMenuItemList(items, cx(styles['submenu'], styles['shadow']))}
					{!isEmpty(itemsInSelectedCategory) &&
            this.getMenuItemList(itemsInSelectedCategory, styles['submenu'], selectedCategoryTitle)}
				</div>));
    }
}
export default NavigationSubMenu;
